module.exports = __webpack_public_path__ + "static/img/2_3.7e3c3c38.jpg";